import axios from 'axios'

const DeleteBlock = ({ documentId,setTickets }) => {

  const deleteTicket = async (e) => {
    const response = await axios.delete(`http://localhost:8000/tickets/${documentId}`)
    const success = response.status == 200
    if (success)
    {
    e.target.parentElement.parentElement.parentElement.children.length<=2 ?
    e.target.parentElement.parentElement.parentElement.style = 'opacity: 0.1; user-select: none; pointer-events: none; cursor: auto;'
    :
    e.target.parentElement.parentElement.style = 'opacity: 0.1; user-select: none; pointer-events: none; cursor: auto;'
    setTimeout(()=>setTickets(prev=>[...prev.filter(ticket=>ticket.documentId!==documentId)]),1000);
    }

  }
  return (
    <div className="delete-block">
      <div className="delete-icon" onClick={deleteTicket}>✖</div>
      </div>
  )
}

export default DeleteBlock